"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRaisedHand = void 0;
/**
 * Returns `true` if the participant has their hand raised.
 */
function hasRaisedHand(discussion, participantId) {
    return discussion.handRaiseQueue.includes(participantId);
}
exports.hasRaisedHand = hasRaisedHand;
//# sourceMappingURL=hasRaisedHand.js.map